import ReservationWidget from './widget-control/ReservationWidget';
import Device from '../src/utility/device/device';
import ReservationWidgetMobile from './widget-control/ReservationWidgetMobile';
import { isMobile } from 'react-device-detect';
import { useResponsive } from './hooks/useResponsive';
import { datadogRum } from '@datadog/browser-rum';


if(process.env.NODE_ENV !== 'development') {
  datadogRum.init({
    applicationId: '366e1f49-4936-44f4-a509-5ad3566244fc',
    clientToken: 'pubb0275669a6434528d001ebb54a737ef2',
    site: 'us5.datadoghq.com',
    service: 'ibe-widget',
    env: process.env.NEXT_PUBLIC_ENV_NAME,
    version: process.env.NEXT_PUBLIC_API_URL?.match(/\/\/(.+?)---/)?.[1] ?? "1.0.0",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 10,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      (url) => url.startsWith("https://ibe-qa-api-7mr6qtnywq-uc.a.run.app"),
      (url) => url.includes("https://ibe-qa.rategain.com"),
    ],
    trackingConsent: 'granted'
  });
}
function App(props: any) {
  // Mobile widget only below 500px; 500px+ → compact desktop widget (stacks < 1200px)
  const { isMobile } = useResponsive();
  return (
    <>
        {isMobile ? <ReservationWidgetMobile props={props} /> : <ReservationWidget props={props} />}
    </>
  )
}

export default App